import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "7",
    r: "2",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "17",
    r: "2",
    fill: "black"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "absolute right-0 mt-2 w-56 rounded-2xl shadow text-sm overflow-hidden z-20"
}
const _hoisted_4 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_5 = { class: "flex flex-col mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-3 items-center text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-xs ml-4" }, " View this template ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-3 items-center text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-xs ml-4" }, " Edit this template ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-3 items-center text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-xs ml-4" }, " Copy this template ")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-3 items-center text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 text-black",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "3",
      y: "4",
      width: "18",
      height: "4",
      rx: "2"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "10",
      y1: "12",
      x2: "14",
      y2: "12"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-xs ml-4" }, " Archive this template ")
], -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsMenuOpen(!_ctx.isMenuOpen))),
      type: "button",
      class: "select-none py-2 px-2 hover:bg-gray-100 rounded"
    }, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: `/get-talent-evaluation?id=${_ctx.templateId}`,
                    class: "rounded px-4 py-2 my-2 hover:bg-background"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: `/edit-talent-evaluation?id=${_ctx.templateId}`,
                    class: "rounded px-4 py-2 my-2 hover:bg-background"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("button", {
                    class: "rounded px-4 py-2 my-2 hover:bg-background",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyTemplate(_ctx.templateId)))
                  }, _hoisted_9),
                  _createElementVNode("button", {
                    class: "rounded px-4 py-2 my-2 hover:bg-background",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.archiveTemplate(_ctx.templateId)))
                  }, _hoisted_11)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512)), [
    [_directive_click_away, _ctx.closeMenu]
  ])
}